import React, { useEffect } from 'react';

import './styles.css';
import Score from '../Score';

type Props = {
  columns: string[];
  sectionName: string;
  onesScore: number;
  sectionScore: number;
  setSectionScore: any;
};

const LowerSection = ({
  columns,
  sectionName,
  onesScore,
  sectionScore,
  setSectionScore,
}: Props) => {

  const rows = [
    'Min',
    'Max',
    'Minimax',
    'Two Pairs',
    'Straight',
    'Full House',
    'Carriage',
    'Yamb',
  ];

  useEffect(() => {
    console.log(onesScore);
  }, [onesScore]);
  
  function changeValue(row: string, amount: number) {
    if (row === 'Min' || row === 'Max') return;
    setSectionScore(sectionScore + amount);
  }

  return (
    <div>
      <div className={'section-name'}>{sectionName}</div>
      <div className={'scoring-section'}>
        <div className={'scoring-column'}>
          <div className={'column-name'}>Name</div>
          {
            rows.map(row => (<div className={'row'} key={`${sectionName}-rowName-${row}`}><div className={'row-name'}>{row}</div></div>))
          }
        </div>
        {columns.map(columnName =>
          (
            <div className={'scoring-column'} key={`${sectionName}-${columnName}`}>
              <div className={'column-name'}>{columnName}</div>
              {
              rows.map(row => (<div className={'row'} key={`${sectionName}-${columnName}-${row}`}><Score callback={(amount: number) => changeValue(row, amount)} /></div>))
              }
            </div>
          )
        )}
      </div>
    </div>
    );
};

export default LowerSection;